import React from "react";

const FormSelect = ({
  label,
  id,
  name,
  value,
  onChange,
  options,
  className = "",
  required = false,
}) => (
  <div className="flex items-center justify-center gap-3 w-full">
    <label htmlFor={id} className="sm:w-44 w-32 text-left font-medium text-gray-700 text-base">
      {label}
    </label>
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      className={`input-field flex-1 w-full max-w-[400px] text-gray-500 ${className}`}
      required={required}
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

export default FormSelect;